import { collection, getDocs, doc, getDoc, query, where } from "firebase/firestore";
import { db } from "../firebase";

export const getCategories = async () => {
  try {
    const categoriesRef = collection(db, "WebshopCategories");
    const querySnapshot = await getDocs(categoriesRef);
    const categories = [];

    querySnapshot.forEach((docSnap) => {
      categories.push({
        id: docSnap.id,
        ...docSnap.data(),
      });
    });

    return categories;
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};

const normalizeProvider = (data) => {
  return {
    ...data,
    categoryId: data.categoryId,
    categoryName: data.categoryName || data.name || "Unknown",
  };
};

export const getProviders = async () => {
  try {
    const providersRef = collection(db, "WebshopProviders");
    const querySnapshot = await getDocs(providersRef);
    const providers = [];

    querySnapshot.forEach((doc) => {
      const providerData = normalizeProvider(doc.data());
      providers.push({
        id: doc.id,
        ...providerData,
      });
    });

    return providers;
  } catch (error) {
    console.error("Error fetching providers:", error);
    return [];
  }
};

export const getProductsByProviderId = async (providerId) => {
  try {
    const productsRef = collection(db, "WebshopProducts");
    const q = query(productsRef, where("providerId", "==", providerId));
    const querySnapshot = await getDocs(q);
    const products = [];

    querySnapshot.forEach((doc) => {
      products.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    return products;
  } catch (error) {
    console.error("Error fetching products by provider:", error);
    return [];
  }
};

export const getProviderById = async (providerId) => {
  try {
    const docRef = doc(db, "WebshopProviders", providerId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const providerData = normalizeProvider(docSnap.data());
      return {
        id: docSnap.id,
        ...providerData,
      };
    }
    return null;
  } catch (error) {
    console.error("Error fetching provider:", error);
    return null;
  }
};

export const getProductById = async (productId) => {
  try {
    const docRef = doc(db, "WebshopProducts", productId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data(),
      };
    }
    return null;
  } catch (error) {
    console.error("Error fetching product:", error);
    return null;
  }
};

export const getProductsByIds = async (productIds) => {
  try {
    if (!productIds || productIds.length === 0) {
      return [];
    }

    const productsRef = collection(db, "WebshopProducts");
    const q = query(productsRef, where("id", "in", productIds));
    const querySnapshot = await getDocs(q);
    const products = [];

    querySnapshot.forEach((doc) => {
      products.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    return products;
  } catch (error) {
    console.error("Error fetching products by IDs:", error);
    return [];
  }
};

export const loadProductData = async (items) => {
  try {
    const productIds = items.map((item) => item.id);
    const products = await getProductsByIds(productIds);

    return items.map((item) => {
      const product = products.find((p) => p.id === item.id);

      if (product) {
        return {
          ...item,
          name: product.name || item.name,
          description: product.description || item.description,
          imageUrl: product.imageUrl || item.imageUrl,
          price: product.price,
          providerId: product.providerId || item.providerId,
        };
      }

      return item;
    });
  } catch (error) {
    console.error("Error enriching items:", error);
    return items;
  }
};
